<template>
  <div class='report-item report-item--featured-question'>
    <div class='text'>
      <div class='actions' v-if='editable && !this.content.stat'>
          <h2 class='editHeading' @click.prevent='onEdit'>Choose featured question <ion-icon name="add-circle-outline"></ion-icon></h2>
        </div>
      <div v-if='currentReport' class='question-breakdown'>
        <QuestionBreakdown ref='questionBreakdown' @change='onBreakdownChange' :translation-context='`${tag}.questionbreakdown`' :editable='false' :circle='true' :config='config.breakdown' :data='currentReport'></QuestionBreakdown>
      </div>
    </div>
    <div v-if='editable'>
      <UIActions @edit='onEdit' @add='onAdd' @delete='onDelete'></UIActions>
    </div>
  </div>
</template>
<script>

import QuestionBreakdown from './QuestionBreakdown.vue'
import TranslationMixin from '../lib/TranslationMixin'
import StatEditor from '../../report-editor/components/StatEditor.vue'
import UIActions from './UIActions.vue'
import Utilities from '../../lib/Utilities.js'

export default {
  props: {
    config: {default: ()=>{{}}, type: Object},
    report: {default: ()=>({}), type: Object},
    response: {type: Object, default: ()=>{{}}},
    editable: {default: true, type: Boolean}
  },
  mixins: [TranslationMixin],
  data () {
    return {
      content: null,
      currentReport: null,
      reports: null
    }
  },
  components: {
    StatEditor,
    QuestionBreakdown,
    UIActions
  },
  methods: {
    onAdd () {
      this.$emit('add')
    },
    onDelete () {
      this.$emit('delete')
    },
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'FeaturedQuestionEditPanel'})
    },
    addStat (event) {
      this.config.stat = event
    },
    onBreakdownChange (event) {
      //console.log(event)
    },
    onEditBreakdown (event) {
      this.$emit('edit', event)
    },
    updateStat () {
      if (this.config.stat){
        this.currentReport = this.reports[this.config.stat]
      }
    }
  },
  created () {
    this.content = this.config
    let questions
    if (!this.response) {
      questions = this.report.questions
    } else {
      questions = this.report.stats
    }
    let reports = {}
    for (let key in questions){
      let question = questions[key]
      const storedSchema = this.report.questionSchema
      const questionIndex = Utilities.getIndexOfObject(storedSchema, 'key', key)
      const questionSchema = storedSchema[questionIndex]
      const questionType = questionSchema.type

      let answers = this.report.answers[key]

      if (questionType === 'checkbox') {
        // debugger
      }

      reports[key] = {questionKey: key, question: this.report.questions[key], stats: this.report.stats[key], answers: answers}

      if (this.response && this.response.answers) {
        let pc
        let answer = this.response.answers[key]
        if (answer === null || typeof answer === 'undefined' || answer === '') {
          pc = 0.0
        } else if (Array.isArray(answer)) {
          let totalPcs = 0
          for (let selection of answer) {
            let aResult = this.report.stats[key][selection]
            totalPcs += aResult.percent
          }
          pc = totalPcs / answer.length
          if (isNaN(pc)) {
            pc = 0
          }
        } else {
          pc = this.report.stats[key][answer].percent
        }
        let responseStat = {
          answer: answer,
          pc: pc,
          type: questionType
        }
        Object.assign(reports[key], responseStat)
      }
    }
    this.reports = reports;
    this.updateStat()
    this.save = _.debounce(function(){
      if (!this.editable) {
        return
      }
      this.$store.dispatch('saveItem', this.config)
    }, 500)
  },
  watch: {
    config: {
      handler: function(config){
        this.updateStat()
        this.$store.commit('setDirty', true)
        this.save()
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
  .actions {
    display: flex;
    min-height: 200px;
    align-items: center;
    justify-content: center;
  }
  .editHeading {
    text-align: center;
    color: #ccc;
    width: 50%;
    cursor: pointer;
    font-size: 200%;
    ion-icon {
      vertical-align: -5px;
    }
  }

  .question-breakdown {
    width: 100%;
    ::v-deep .question-breakdown--content {
      width: 90%;
      margin: auto;
      padding: 5% 0;
    }

    ::v-deep hr {
      //margin-bottom: 1rem;
    }
    @media (min-width: 758px){
      ::v-deep .question-breakdown--content {
        width: 80%;
      }
    }
    margin:auto;
  }
</style>